import React from 'react';
import { Box } from '@mui/material';
import PageTitle from '../../components/PageTitle';
import FirstPromoterCampaignsTableAreaAdmin from '../../components/FirstPromoterCampaignsTableAreaAdmin/FirstPromoterCampaignsTableAreaAdmin';

const FirstPromoterCampaignsPageAdmin = () => {
  return (
    <Box sx={{
      py: 3, px: 4, width: '100%', display: 'flex', flexDirection: 'column', gap: 3,
    }}
    >
      <PageTitle title="FirstPromoter Campaigns" />
      <FirstPromoterCampaignsTableAreaAdmin />
    </Box>
  );
};

export default FirstPromoterCampaignsPageAdmin;
